import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=3fd64d06&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"
import style0 from "./HomePage.vue?vue&type=style&index=0&id=3fd64d06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd64d06",
  null
  
)

export default component.exports